import { render, staticRenderFns } from "./OscillographyAnalysisTab.vue?vue&type=template&id=00115744&scoped=true&"
import script from "./OscillographyAnalysisTab.vue?vue&type=script&lang=js&"
export * from "./OscillographyAnalysisTab.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyAnalysisTab.vue?vue&type=style&index=0&id=00115744&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00115744",
  null
  
)

export default component.exports